import React from 'react'
import { auth } from "services/firebase";

import logo from 'assets/images/logo-cybersescgo.svg'

export default function Navbar(props) {
  const { isLogged } = props;

  const handleLogout = () => {
    auth.signOut().then(() => {
      // Sign-out successful.
      console.log("Signed out successfully")
    }).catch((error) => {
      console.log(error)
    });
  }

  return (
    <nav className="navbar navbar-expand-sm">
      <div className="container">
        <div className="w-100 d-flex justify-content-between">
          <a href="https://cybersecgo.com.br/">
            <img src={logo} alt="umic logo" className="navbar-brand" />
          </a>
          {
            isLogged ?
              <div className='my-auto'>
                <button className='btn btn-sm btn-outline-light' onClick={handleLogout}>LOGOUT</button>
              </div> : null
          }
        </div>
      </div>
    </nav>
  )
}
